import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import cleanup from "../utils/barcode_cleanup"

export const Barcode = CreateRenderFunction({
  data: {
    barcode: "",
  },
  init() {
    this.barcode = cleanup(this.value)
  },
  methods: {
    cleanup() {
      this.barcode = cleanup(this.barcode)
    },
  },
  props: {
    name: "",
    placeholder: "",
    value: "",
  },
  render() {
    return (
      <input
        autocomplete="off"
        class="form-control"
        name={this.name}
        onInput={(e: Event) => {
          this.barcode = (e.target as HTMLInputElement).value
        }}
        placeholder={this.placeholder}
        type="text"
        value={this.barcode}
      />
    )
  },
  watch: {
    barcode() {
      this.cleanup()
    },
  },
})
